import { Component, ElementRef, input, OnInit, ViewChild } from '@angular/core';
import { ApplicationAppEntityApplicationRead } from '../../../../../openapi';
import { environment } from '../../../../../../environments/environment';
import { safeContentPipe } from '../../../../../pipes/safe-content.pipe';

@Component({
  selector: 'app-upp-preview',
  standalone: true,
  imports: [
    safeContentPipe
  ],
  templateUrl: './upp-preview.component.html'
})
export class UppPreviewComponent implements OnInit {

  @ViewChild('dialog', { static: true })
  public dialog: ElementRef | undefined;

  public application = input<ApplicationAppEntityApplicationRead | null>();

  public show(): void {
    const dialog: HTMLDialogElement = this.dialog?.nativeElement as HTMLDialogElement;
    dialog.showModal();
  }

  public ngOnInit(): void {

  }

  protected readonly env = environment;
}
